import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const NextIcon = (props) => (
  <SvgIcon {...props}>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      1,5 5,12 1,19 "/>
  </SvgIcon>
);

export default NextIcon;



// WEBPACK FOOTER //
// ./src/icons/NextIcon.jsx